/**
 * Sitra Brand Colors
 * Based on official Sitra visual identity guidelines
 *
 * Usage: import { SCENARIO_COLORS, BRAND_COLORS } from '../config/brandColors';
 */

// Primary brand colors (Brändivärit)
export const BRAND_COLORS = {
  white: '#FFFFFF',
  black: '#000000',
  yellow: '#FFD93D',      // Primary yellow
  blue: '#367ABA',        // Sitra blue
  orange: '#F5A623',      // Primary orange
  cyan: '#5DCEDB',        // Light blue/cyan
  red: '#E8114B',         // Sitra Puolukka
  green: '#008549',       // Sitra green
  pink: '#E8114B',        // Sitra Puolukka
  lime: '#A6D64D',        // Lime green
};

// Secondary palette (Apuväripaletti) - lighter versions
export const SECONDARY_COLORS = {
  yellowLight: '#FFF3C4',
  blueLight: '#D4E5F7',
  orangeLight: '#FFE5C4',
  cyanLight: '#D4F4F7',
  pinkLight: '#FCE4EC',
  greenLight: '#C8E6C9',
  limeLight: '#F0F4C3',
};

// Neutral grays
export const NEUTRALS = {
  100: '#1A1A1A',
  90: '#333333',
  80: '#4D4D4D',
  70: '#666666',
  60: '#808080',
  50: '#999999',
  40: '#B3B3B3',
  30: '#CCCCCC',
};

/**
 * Scenario Colors - Official mapping per issue #44
 * - Demokratia: keltainen (yellow)
 * - Väestö: vaaleanpunainen (light pink)
 * - Teknologia: vihreä (green)
 * - Ilmasto: sininen (blue)
 */
export const SCENARIO_COLORS = {
  demokratia: BRAND_COLORS.yellow,
  Demokratia: BRAND_COLORS.yellow,

  vaesto: BRAND_COLORS.pink,
  väestö: BRAND_COLORS.pink,
  Väestö: BRAND_COLORS.pink,

  teknologia: BRAND_COLORS.green,
  Teknologia: BRAND_COLORS.green,

  ilmasto: BRAND_COLORS.blue,
  Ilmasto: BRAND_COLORS.blue,
};

// For backwards compatibility
export const SCENARIO_COLORS_BY_NAME = SCENARIO_COLORS;

/**
 * AI accent — every AI trigger button uses this (per brand guide).
 * Matches Report SITRA.purple / Solutions EnrichBtn.
 */
export const AI_COLORS = {
  base: '#7c3aed',
  deep: '#6d28d9',   // gradient end
  light: '#8b5cf6',  // hover
  text: '#a78bfa',   // text/icon on dark
};

export default {
  BRAND_COLORS,
  SECONDARY_COLORS,
  NEUTRALS,
  SCENARIO_COLORS,
  SCENARIO_COLORS_BY_NAME,
  AI_COLORS,
};
